import React from 'react';
import { useUiTheme } from 'framework/uiTheme';
import useFieldHelper from './fieldHelper';
import { BaseFieldLayoutType, FieldProps } from './types';

interface CommaListFieldProps extends FieldProps<string | string[] | any> {
  mapValue?: (obj: any) => string | React.ReactElement;
  isNeedJoin?: boolean;
  emptyPlaceholder?: string;
}

const CommaListField = ({ mapValue, isNeedJoin = true, ...props }: CommaListFieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const initialValue = getValue();

  const processedValue =
    initialValue &&
    Array.isArray(initialValue) &&
    initialValue.length > 0 &&
    (mapValue ? initialValue.map(mapValue) : initialValue);

  const joinedValue = isNeedJoin && processedValue ? processedValue.join(', ') : processedValue;

  const displayValue = joinedValue && joinedValue.length !== 0 ? joinedValue : null;

  return <BaseFieldLayout label={getLabel()} value={displayValue} />;
};

export default CommaListField;
